import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  Chip,
  Stack,
  Avatar,
  ButtonProps,
  Card,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useAppSelector } from "../../Redux/Store/Hooks";
import { ReactComponent as MyIcon } from "./ImageforDashboardStudent/reading.svg";
import { ReactComponent as MyIcon2 } from "./ImageforDashboardStudent/reading4.svg";
import { ReactComponent as MyIcon3 } from "./ImageforDashboardStudent/reading5.svg";
import { ReactComponent as MyIcon4 } from "./ImageforDashboardStudent/reading2.svg";
import { ReactComponent as MyIcon5 } from "./ImageforDashboardStudent/reading3.svg";
import { ReactComponent as Question_Grinder } from "./ImageforDashboardStudent/Group 26.svg";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../Redux/Store/Store";
import { ListRecommended_Action } from "../../Redux/Slices/DashboardData/Recommended_Actions";
import { useNavigate } from "react-router-dom";

const ActivityDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { data: listRecent } = useAppSelector(
    (state) => state.ListRecentActivitySlice
  );
  const { data: recommendedActions } = useAppSelector(
    (state) => state.Recommended_ActionSlicer
  );

  useEffect(() => {
    dispatch(ListRecommended_Action());
  }, [dispatch]);

  const icons = [MyIcon, MyIcon2, MyIcon3, MyIcon4, MyIcon5];
  const shuffleArray = (array: any[]) => {
    return array
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  };

  const RecentActivity: any = shuffleArray(listRecent?.data ?? []).map(
    (user: any, index: number) => ({
      ...user,
      icon: icons[index % icons.length],
    })
  );

  const Suggestions = recommendedActions?.data?.recommendation;
  // time convert
  const formatTimeToMinutes = (time?: string): string => {
    if (!time) return "0min";
    const parts = time.split(":").map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return "0min";
    const [hours, minutes, seconds] = parts;
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    const totalMinutes = Math.floor(totalSeconds / 60);
    return `${totalMinutes}min`;
  };

  // date convert
  const formatDateDifference = (dateString: string): string => {
    const inputDate = new Date(dateString);
    const today = new Date();
    const inputMidnight = new Date(
      inputDate.getFullYear(),
      inputDate.getMonth(),
      inputDate.getDate()
    );
    const todayMidnight = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const diffTime = todayMidnight.getTime() - inputMidnight.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    return `${diffDays} days ago`;
  };

  const [showAll, setShowAll] = useState(false);

  const visibleActivities = showAll
    ? RecentActivity
    : RecentActivity?.slice(0, 3);

  // convert recommendations
  const transformedRecommendations = recommendedActions?.data?.marks_by_type
    ? Object.entries(recommendedActions.data.marks_by_type).map(
        ([title, value], idx) => ({
          icon: icons[idx % icons.length],
          title,
          subtitle: ` ${value}`,
          button: {
            label: "Practice",
            variant: "contained",
            disabled: false,
          },
        })
      )
    : [];

  const sortedRecs = [...transformedRecommendations].sort(
    (a, b) => Number(a.subtitle) - Number(b.subtitle)
  );

  const lowest = sortedRecs[0];
  const highest = sortedRecs[sortedRecs.length - 1];
  return (
    <Card sx={{ mt: 3, boxShadow: "0px 2px 12px rgba(0,0,0,0.05)", p: 2 }}>
      <Grid container spacing={2}>
        {/* Recent Activity (70%) */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper sx={{ p: 2, height: "100%" }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ fontSize: "19px" }}
              >
                Recent Activity
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                sx={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "Show Less" : "View All"}
              </Typography>
            </Box>

            <Stack spacing={2}>
              {RecentActivity?.length > 0 ? (
                visibleActivities?.map((item: any, idx: any) => (
                  <Paper
                    key={idx}
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#f9fafb",
                      border: "none",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <item.icon style={{ strokeWidth: 2 }} />
                      <Box>
                        <Typography fontWeight={500} sx={{ fontSize: "16px" }}>
                          {item.name}
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <AccessTimeIcon
                            fontSize="small"
                            sx={{ opacity: 0.6 }}
                          />
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: "14px" }}
                          >
                            {formatTimeToMinutes(item.total_time_taken)}
                          </Typography>
                          <Chip
                            label={`${item.percentage}%`}
                            size="small"
                            sx={{
                              backgroundColor: "#FFCDD2",
                              fontWeight: 400,
                              color: "#991b1b",
                              ml: 1,
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: "13px" }}
                    >
                      {formatDateDifference(item.date_attended)}
                    </Typography>
                  </Paper>
                ))
              ) : (
                <Box px={2} py={4} textAlign="center">
                  <Typography variant="body1" color="text.secondary">
                    No data found
                  </Typography>
                </Box>
              )}
            </Stack>
          </Paper>
        </Grid>

        {/* Recommended Actions (30%) */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper sx={{ p: 2, borderRadius: 2 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ fontSize: "19px", marginBottom: "20px" }}
            >
              Recommended Actions
              <Typography>{Suggestions}</Typography>
            </Typography>

            <Stack spacing={2}>
              {transformedRecommendations.length > 0 ? (
                <>
                  {/* 1. Lowest Score */}
                  {lowest && (
                    <Paper
                      variant="outlined"
                      sx={{
                        p: "14px",
                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "17px",
                        backgroundColor: "#f9fafb",
                        border: "none",
                      }}
                    >
                      <Box display="flex" gap={2}>
                        <Avatar sx={{ background: "none", color: "red" }}>
                          <Question_Grinder />
                        </Avatar>

                        <Box>
                          <Typography fontWeight="500" fontSize={"14px"}>
                            {lowest.title} needs attention
                          </Typography>
                          <Typography
                            variant="body2"
                            fontSize={"12px"}
                            color="text.secondary"
                            marginTop={"5px"}
                          >
                            Your accuracy is {lowest.subtitle} - lower than
                            average
                          </Typography>
                        </Box>
                      </Box>
                      <Button
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          fontSize: "15px",
                          color: "#fff",
                          backgroundColor: "#0055ff",
                          "&:hover": {
                            backgroundColor: "#0055ff", // light blue on hover
                          },
                        }}
                        onClick={() => navigate("/examhistory")}
                      >
                        Review Concepts
                      </Button>
                    </Paper>
                  )}

                  {/* 2. Highest Score */}
                  {highest && (
                    <Paper
                      variant="outlined"
                      sx={{
                        p: "14px",
                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "17px",
                        backgroundColor: "#f9fafb",
                        border: "none",
                      }}
                    >
                      <Box display="flex" gap={2}>
                        <Avatar sx={{ background: "none" }}>
                          <MyIcon4 />
                        </Avatar>
                        <Box>
                          <Typography fontWeight="500" fontSize={"14px"}>
                            Ready for {highest.title}
                          </Typography>
                          <Typography
                            variant="body2"
                            fontSize={"12px"}
                            color="text.secondary"
                            marginTop={"5px"}
                          >
                            You've mastered the basics ({highest.subtitle}{" "}
                            accuracy)
                          </Typography>
                        </Box>
                      </Box>
                      <Button
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          "&:hover": {
                            color: "white",
                            backgroundColor: "#38C172",
                          },
                        }}
                        onClick={() => navigate("/practicetest")}
                      >
                        Practice More
                      </Button>
                    </Paper>
                  )}

                  {/* 3. General Suggestion */}
                  <Paper
                    variant="outlined"
                    sx={{
                      p: "14px",
                      borderRadius: 2,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      gap: "17px",
                      backgroundColor: "#f9fafb",
                      border: "none",
                    }}
                  >
                    <Box display="flex" gap={2}>
                      <Avatar sx={{ background: "none" }}>
                        <MyIcon5 />
                      </Avatar>
                      <Box>
                        <Typography fontWeight="500" fontSize={"14px"}>
                          Ready for a Mock Test
                        </Typography>
                        <Typography
                          variant="body2"
                          fontSize={"12px"}
                          color="text.secondary"
                          marginTop={"5px"}
                        >
                          You've completed enough section practice
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        fontSize: "14px",
                        backgroundColor: "#fff",
                        "&:hover": {
                          color: "white",
                          backgroundColor: "#38C172",
                        },
                      }}
                      onClick={() => navigate("/mockexam")}
                    >
                      Start Mock
                    </Button>
                  </Paper>
                </>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No recommendations found
                </Typography>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ActivityDashboard;
